import { Controller } from "@hotwired/stimulus"

// Handles responsive form behavior for both desktop and mobile
export default class extends Controller {
  connect() {
    console.log('ResponsiveForm controller connected to:', this.element)

    // Add mobile class if needed
    if (window.innerWidth < 768) {
      this.element.classList.add('is-mobile')
    }

    // Handle escape key — store bound reference for proper cleanup
    this._boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this._boundHandleKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this._boundHandleKeydown)
  }

  close() {
    console.log('ResponsiveForm close() called')
    const frame = this.element.closest('turbo-frame')
    console.log('Found turbo-frame:', frame)
    
    if (frame) {
      // Check if we're in a sidebar context
      const sidebar = this.element.closest('[data-sidebar-target="sidebar"]')
      console.log('Found sidebar:', sidebar)
      
      if (sidebar) {
        // In sidebar context: try to go back to previous content gracefully
        // Option 1: Check if there's a data attribute for previous URL
        const previousUrl = frame.dataset.previousUrl
        if (previousUrl) {
          // Navigate back to previous content
          frame.src = previousUrl
          return
        }
        
        // Option 2: Look for a cancel link or back button in the form
        const cancelLink = this.element.querySelector('a[href*="back"], a.cancel, a[data-action*="cancel"]')
        if (cancelLink && cancelLink.href) {
          // Use the cancel link's destination
          frame.src = cancelLink.href
          return
        }
        
        // Option 3: Graceful fallback - show a "closed" message instead of empty
        frame.innerHTML = `
          <div class="p-4 text-center">
            <p class="text-gray-500">Form closed</p>
            <p class="text-sm text-gray-400 mt-2">
              <a href="#" onclick="window.location.reload()" class="text-blue-500 hover:underline">
                Refresh to reload content
              </a>
            </p>
          </div>
        `
      } else {
        // Non-sidebar context: use original behavior for modal/inline forms
        const emptyContent = document.createElement('div')
        emptyContent.id = frame.id
        frame.innerHTML = ''
        frame.appendChild(emptyContent)
      }
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
} 